import Vue from 'vue';
import {extend, localize, ValidationObserver, ValidationProvider} from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import {i18n} from '@/setup/i18n-setup';

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

// loop over all rules
for (let rule in rules) {
    // add the rule
    extend(rule, rules[rule]);
}

extend('password', {
    validate: (value, {other}) => value === other,
    message: 'The password confirmation does not match.',
    params: [{name: 'other', isTarget: true}]
});

function loadLocale() {
    const code = i18n.locale;

    return import(`vee-validate/dist/locale/${code}.json`).then(locale => {
        localize(code, locale);
    });
}

loadLocale();